import TitleResult from "components/common/title-result";
import Container from "components/ui/container";
import React, { Fragment } from "react";

const HeaderMobileFilters = ({
    isMenuActive,
    isClickedBtn,
    totalComposers,
    totalWorks,
    children
}) => {
    return (
        <div className="block lg:hidden">
            <Container>
                <TitleResult
                    customClassName="text-left"
                    isMenuActive={isMenuActive}
                    isClickedBtn={isClickedBtn}
                    totalComposers={totalComposers}
                    totalWorks={totalWorks}
                />
            </Container>

            <Container>
                <div className="grid gap-2 grid-cols-2">
                    <Fragment>
                        {children}
                    </Fragment>
                </div>
            </Container>
        </div>
    )
}

export default HeaderMobileFilters;
